module.exports = __webpack_public_path__ + "img/zoushi.6f7f0c9c.png";